<template>
  <div id="app">
    <!-- navbar -->
    <b-navbar
      class="top-bar font-weight-bold mb-3"
      toggleable="lg"
      type="dark"
      variant="vtx"
    >
      <!-- logo -->
      <b-navbar-brand class="py-0" active :to="{ name: 'home' }">
        <img
          class="d-inline-block align-bottom"
          :src="require('@/assets/vtx-logo-white.png')"
          alt="logo"
        />
      </b-navbar-brand>
      <!-- <b-navbar-toggle target="nav_collapse">
				<template v-slot:default="{ expanded }">
					<font-awesome-icon v-if="expanded" :icon="['fas', 'chevron-up']" class="align-middle" />
					<font-awesome-icon v-else :icon="['fas', 'hamburger']" class="align-middle" />
				</template>
			</b-navbar-toggle>-->

      <!-- install button -->
      <!-- <ul v-if="isLoggedIn && installBtn" class="nav navbar-nav mr-auto">
				<b-nav-form>
					<b-button variant="warning" type="submit" @click.prevent="installer()">
						<font-awesome-icon :icon="['fas', 'tools']" />&nbsp;Install
					</b-button>
				</b-nav-form>
			</ul>-->

      <!-- menu -->
      <b-navbar-toggle target="nav_collapse" />
      <b-collapse id="nav_collapse" is-nav visible>
        <!-- stats -->
        <b-navbar-nav v-if="isLoggedIn" class="text-center">
          <b-nav-item :to="{ name: 'stats' }" exact>Stats</b-nav-item>
        </b-navbar-nav>

        <!-- accept protocol -->
        <b-navbar-nav v-if="isLoggedIn" class="top-menu-drop text-center">
          <b-nav-item-dropdown
            text="Accept Protocol"
            menu-class="border-top-0 rounded-bottom"
          >
            <b-container>
              <b-row>
                <!-- new -->
                <b-col cols="12" sm="12" md="4" lg="4" xl="4">
                  <b-dropdown-item :to="{ name: 'accept-protocol-new' }" exact>
                    <div class="row d-flex tab h-100">
                      <div class="fa-icon text-primary text-center">
                        <font-awesome-icon
                          :icon="['fas', 'plus']"
                          class="align-middle"
                        />
                      </div>

                      <div class="d-flex flex-column align-self-end">
                        <h6 class="mb-0">New</h6>
                        <small class="text-muted"
                          >Create new accept protocol</small
                        >
                      </div>
                    </div>
                  </b-dropdown-item>
                </b-col>
                <!-- list pending -->
                <b-col cols="12" sm="12" md="4" lg="4" xl="4">
                  <b-dropdown-item
                    :to="{
                      name: 'accept-protocol-list',
                      params: { state: 'all' },
                    }"
                    exact
                  >
                    <div class="row d-flex tab">
                      <div class="fa-icon text-warning text-center">
                        <font-awesome-icon
                          :icon="['far', 'hourglass']"
                          class="align-middle"
                        />
                      </div>

                      <div class="d-flex flex-column align-self-end">
                        <h6 class="mb-0">Pending</h6>
                        <small class="text-muted">List of ongoing</small>
                      </div>
                    </div>
                  </b-dropdown-item>
                </b-col>
                <!-- list finalized -->
                <b-col cols="12" sm="12" md="4" lg="4" xl="4">
                  <b-dropdown-item
                    :to="{
                      name: 'accept-protocol-finalized-list',
                      params: { state: 'all' },
                    }"
                    exact
                  >
                    <div class="row d-flex tab">
                      <div class="fa-icon text-success text-center">
                        <font-awesome-icon
                          :icon="['fas', 'check']"
                          class="align-middle"
                        />
                      </div>

                      <div class="d-flex flex-column align-self-end">
                        <h6 class="mb-0">Finalized</h6>
                        <small class="text-muted">List of completed</small>
                      </div>
                    </div>
                  </b-dropdown-item>
                </b-col>
              </b-row>
            </b-container>
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <!-- accept protocol templates-->
        <b-navbar-nav v-if="isLoggedIn" class="top-menu-drop text-center">
          <b-nav-item-dropdown
            text="Templates"
            menu-class="border-top-0 rounded-bottom"
          >
            <b-container class="justify-content-center">
              <b-row>
                <!-- new -->
                <b-col cols="12" sm="auto" md="auto" lg="auto" xl="auto">
                  <b-dropdown-item
                    :to="{ name: 'accept-protocol-template-new' }"
                    exact
                  >
                    <div class="row d-flex tab h-100">
                      <div class="fa-icon text-success text-center">
                        <font-awesome-icon
                          :icon="['fas', 'plus']"
                          class="align-middle"
                        />
                      </div>

                      <div class="d-flex flex-column align-self-end">
                        <h6 class="mb-0">New</h6>
                        <small class="text-muted">Create new template</small>
                      </div>
                    </div>
                  </b-dropdown-item>
                </b-col>
                <!-- list availabe templates -->
                <b-col cols="12" sm="auto" md="auto" lg="auto" xl="auto">
                  <b-dropdown-item
                    :to="{ name: 'accept-protocol-template-list' }"
                    exact
                  >
                    <div class="row d-flex tab">
                      <div class="fa-icon text-info text-center">
                        <font-awesome-icon
                          :icon="['fas', 'list']"
                          class="align-middle"
                        />
                      </div>

                      <div class="d-flex flex-column align-self-end">
                        <h6 class="mb-0">List</h6>
                        <small class="text-muted"
                          >List of available templates</small
                        >
                      </div>
                    </div>
                  </b-dropdown-item>
                </b-col>
              </b-row>
            </b-container>
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav v-if="isLoggedIn" class="ml-auto mr-2 text-center" split>
          <li class="d-none d-lg-block">
            <b-img
              rounded="circle"
              :src="user.thumbnail"
              alt="current user avatar"
              width="50"
            ></b-img>
          </li>
          <b-dropdown-divider class="divider-parent"></b-dropdown-divider>
          <b-nav-item-dropdown :text="user.name" right>
            <b-dropdown-item
              class="text-center"
              :to="{ name: 'user-settings' }"
              exact
              >Profile</b-dropdown-item
            >
            <b-dropdown-item class="text-center" @click="logout"
              >Log me out</b-dropdown-item
            >
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <b-navbar-nav
          v-if="!isLoggedIn && !customerArea && routeName !== 'login'"
          class="ml-auto mr-2 text-center"
          split
        >
          <li>
            <b-nav-item :to="{ name: 'login' }">
              <font-awesome-icon :icon="['fas', 'user-secret']" />&nbsp;Login
            </b-nav-item>
          </li>
        </b-navbar-nav>

        <!-- <ul v-if="!isLoggedIn && !customerArea" class="nav navbar-nav ml-auto">
					<li>
						<b-button variant="warning" type="submit" :to="{ name: 'login' }">
							<font-awesome-icon :icon="['fas', 'user-secret']" />&nbsp;Login
						</b-button>
					</li>
				</ul>-->

        <!-- <b-navbar-nav v-if="!isLoggedIn && !customerArea" class="mx-auto">
					<b-nav-item :to="{ name: 'login' }" class="text-center py-3">Login</b-nav-item>
				</b-navbar-nav>-->
      </b-collapse>
    </b-navbar>
    <!--/ navbar -->

    <!-- <transition name="fade" mode="out-in"> -->
    <router-view />
    <!-- </transition> -->

    <footer class="footer">
      <div class="container">
        <small class="text-muted">chimbi@2019</small>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "App",

  data() {
    return {
      installBtn: true,
      installer: undefined,
    };
  },

  computed: {
    ...mapState("account", ["user"]),
    ...mapGetters("account", ["isLoggedIn"]),
    routeName() {
      return this.$route.name;
    },
    customerArea() {
      return this.$route.meta.customerArea;
    },
  },
  methods: {
    ...mapActions("account", ["logout"]),
  },
  created() {
    console.clear();

    // let installPrompt;

    // window.addEventListener("beforeinstallprompt", e => {
    // 	e.preventDefault();
    // 	installPrompt = e;
    // 	this.installBtn = true;
    // });

    // this.installer = () => {
    // 	this.installBtn = false;
    // 	if (installPrompt) {
    // 		installPrompt.prompt();
    // 		installPrompt.userChoice.then(result => {
    // 			if (result.outcome === "accepted") {
    // 				console.log("Install accepted!");
    // 			} else {
    // 				console.log("Install denied!");
    // 			}
    // 		});
    // 	} else {
    // 		console.log("no service workers found. App.vue says it");
    // 	}
    // };
  },
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

html {
  /* fix jumping scroll */
  /* https://stackoverflow.com/questions/1417934/how-to-prevent-scrollbar-from-repositioning-web-page */
  // overflow-x: hidden;
  // margin-right: calc(100% - 100vw);
  padding-bottom: 40px;
}

.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  /* Set the fixed height of the footer here */
  height: 30px;
  line-height: 30px; /* Vertically center the text there */
  background-color: #f5f5f5;
}

// navbar -> divider
.divider-parent > hr {
  border-color: #7ebcfa;
}

/**/
// top menu item icon
.fa-icon {
  font-size: 30px;
  color: #fff;
  background-color: #d8eafd;
  margin: 2px 10px 5px 0px;
  border-radius: 10px;
  width: 50px;
  height: 50px;
}

.top-menu-drop .nav-item {
  font-size: 16px;
  position: static;
}

.navbar-collapse.collapse.in {
  display: block !important;
}

.top-menu-drop .dropdown-menu {
  margin-top: -14px;
  // border: none;
  padding: 30px 10px 30px 50px;
  left: auto;
  background-color: #f8fbfe;
  border: solid 1px #7ebcfa;
  border-radius: 0;
}

.tab {
  min-width: 250px;
}

.tab:hover {
  color: #e91e63 !important;
}

.top-menu-drop .dropdown-item {
  padding: 0px;
  color: #063f7b;
}

.top-menu-drop .dropdown-item:hover {
  background-color: inherit;
}

.top-menu-drop .dropdown-item.active,
.top-menu-drop .dropdown-item:active {
  background-color: transparent;
  color: #e91e63;
}

// Medium devices (tablets, less than 992px)
@media (max-width: 991.98px) {
  .top-menu-drop .dropdown-menu {
    margin-top: auto;
  }
}
</style>
